import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";

// Firebase Imports
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyC1-9n6X-tg3yjYu6MhWRWNh2UdtBcjdeY",
  authDomain: "entain-ally.firebaseapp.com",
  projectId: "entain-ally",
  storageBucket: "entain-ally.appspot.com",
  messagingSenderId: "154493300171",
  appId: "1:154493300171:web:783ae9289574d0e9751a4e",
  measurementId: "G-XM6BFXWXQJ"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

root.render(
  <StrictMode>
    <ColorModeScript />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
